import { tsValidateArray, tsValidateOptionalId, tsValidateUniqueId, tsValidateValue, tsValidator_arrayOfUniqueIds } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_ModifiableProps = {
    leftSide: tsValidateArray({ valueId: tsValidateOptionalId, variableId: tsValidateUniqueId }),
    relation: tsValidateValue(['Contains', 'Member Of', 'Derivative', 'Convert To Enum', 'Relieving Factor', 'Precipitating Factor']),
    rightSide: tsValidateArray({ valueId: tsValidateOptionalId, variableId: tsValidateUniqueId }),
};
const Validator_GeneratedProps = {
    _firstVariableId: tsValidateUniqueId,
    _valueIds: tsValidator_arrayOfUniqueIds,
    _variableIds: tsValidator_arrayOfUniqueIds,
    _origin: tsValidateOptionalId,
};
export const DBDef_VariableRelation = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'variable-relation',
    entityName: 'VariableRelation',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'variable-relation'
    },
    backend: {
        name: 'variable-relation'
    },
    dependencies: {
        _variableIds: { dbKey: 'variables', fieldType: 'string[]' },
        _valueIds: { dbKey: 'values', fieldType: 'string[]' },
        _firstVariableId: { dbKey: 'variables', fieldType: 'string' },
    }
};
//# sourceMappingURL=db-def.js.map